export default "__VITE_ASSET__DHI84zT___"